<template>
  <el-table-column
    prop="status"
    label="Meghiusulás oka"
    min-width="170"
  >
    <template slot-scope="scope">
      {{ reasons(scope.row.failure_reason) }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'location.value',

    methods: {
      reasons(reason) {
        let reasons = {
          'not-enough-cash': "Nem volt elég készpénz",
          'enough-stock': "Volt elég készlet",
          'shop-closed': "Zárva volt",
        }

        return reasons[reason];
      }
    }
  };
</script>
